import React, { useState } from "react";
import { TextField, MenuItem, Button, Box, Typography } from "@mui/material";
import axios from "axios";
import { envData } from "../../envs";

const CertificateGenerator = () => {
  const [award, setAward] = useState("");
  const [grade, setGrade] = useState("");
  const [exam, setExam] = useState("");
  const [name, setName] = useState("");

  const handleGenerate = async () => {
    try {
      const params = {
        fullName: name,
        cert_type: award,
        grade: grade,
        exam_name: exam,
        type: "generate",
      };

      const response = await axios.get(
        `${envData.baseApiUrl}/v1/students/student/certificate`,
        {
          params,
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      const blobUrl = URL.createObjectURL(response.data);
      const newTab = window.open();
      newTab.location.href = blobUrl;
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      console.error("Error generating certificate:", error);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 5,
        p: 3,
        border: "1px solid #ccc",
        borderRadius: 2,
        boxShadow: 2,
      }}
    >
      <Typography variant="h5" mb={3} textAlign="center">
        Create New Certificate
      </Typography>

      <TextField
        select
        label="Select Award"
        fullWidth
        value={award}
        onChange={(e) => setAward(e.target.value)}
        margin="normal"
      >
        <MenuItem value="">None</MenuItem>
        <MenuItem value="gold">Gold</MenuItem>
        <MenuItem value="silver">Silver</MenuItem>
        <MenuItem value="bronze">Bronze</MenuItem>
        <MenuItem value="prtcpnt">Participant</MenuItem>
      </TextField>

      <TextField
        select
        label="Select Grade"
        fullWidth
        value={grade}
        onChange={(e) => setGrade(e.target.value)}
        margin="normal"
      >
        <MenuItem value="">None</MenuItem>
        {[...Array(12)].map((_, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label="Select Exam Type"
        fullWidth
        value={exam}
        onChange={(e) => setExam(e.target.value)}
        margin="normal"
      >
        <MenuItem value="">None</MenuItem>
        <MenuItem value="cogat">Cogat</MenuItem>
        <MenuItem value="math">Math</MenuItem>
        <MenuItem value="robot">Robot</MenuItem>
        <MenuItem value="art">Art</MenuItem>
      </TextField>

      <TextField
        label="Full Name"
        fullWidth
        value={name}
        onChange={(e) => setName(e.target.value)}
        margin="normal"
      />

      <Button
        variant="contained"
        color="primary"
        onClick={handleGenerate}
        fullWidth
        sx={{ mt: 2 }}
      >
        Generate
      </Button>
    </Box>
  );
};

export default CertificateGenerator;
